export default __webpack_public_path__ + "static/media/Nogg's Club of Hate.4ab91913.jpg";